import TreatmentList from "issara-sdk/apis/TreatmentList_apps_TRT";
import icd9cmKeyUp from "issara-sdk/apis/icd9cmKeyUp_core";
import SupplyDetail from "issara-sdk/apis/SupplyDetail_apps_MSD";
import OrderSetTemplateList from "issara-sdk/apis/OrderSetTemplateList_apps_PTM";
import OrderSetTemplateDetail from "issara-sdk/apis/OrderSetTemplateDetail_apps_PTM";
import CentralLabOrderList from "issara-sdk/apis/CentralLabOrderList_apps_LAB";
import ImagingOrderList from "issara-sdk/apis/ImagingOrderList_apps_IME";
import TreatmentOrderList from "issara-sdk/apis/TreatmentOrderList_apps_TRT";
import SupplyOrderList from "issara-sdk/apis/SupplyOrderList_apps_MSD";
import DoctorDetail from "issara-sdk/apis/DoctorDetail_core";
import MiscellaneousOrderListCreate from "issara-sdk/apis/MiscellaneousOrderListCreate_core";
import SupplyOrderPreview from "issara-sdk/apis/SupplyOrderPreview_apps_MSD";

import WasmController from "../../../../frameworks/WasmController";
import { State as MainState } from "../../../../../HIS/MainHISInterface";
import { SetProperty } from "../CommonInterface";
import { AdminMenuListKey } from "../../HRM/HRMInterface";
import moment from "moment";
import { formatDate } from "react-lib/utils/dateUtils";

export type Props = {};

export type State = {
  // sequence
  OrderSetTemplateSequence?: OrderSetTemplateSequence;

  // CommonInterface
  selectedEncounter?: Record<string, any>;
  selectedEmr?: Record<string, any>;
  buttonLoadCheck?: Record<string, any>;
  errorMessage?: Record<string, any>;
};

type PickedState = Partial<Pick<MainState, "buttonLoadCheck" | "django" | "errorMessage">>;

export type SetProp = SetProperty<State & PickedState>;

export type OrderSetTemplateSequence = {
  sequenceIndex?: string | null;
  selectDetail?: SelectDetailType;
  selectTemplate?: SelectTemplateType;
  searchTemplate?: SearchTemplateType;
  templateList?: [];
  searchIcd9?: any;
  // order
  checkBoxTemplate?: CheckBoxTemplateType;
  // supplyQA
  supplyQA?: any[];
  supplyOrderPreview?: any[];
  // duplicateLabDetected
  duplicateLabDetected?: string[];
};

export type adminMenuDivisionType = Record<
  string,
  Partial<Record<AdminMenuListKey, { divisions: Record<string, any>[]; tabs: string[] }>>
>;

export type SelectDetailType = {
  icd9?: {
    icd10_id?: number;
    icdcode?: string;
    icdterm?: string;
    medterm?: string;
    sublevel?: boolean;
  };
  code?: string;
  name?: string;
  orderType?: string;
  dose?: string;
  route?: string;
  site?: string;
  frequency?: number;
  method?: string;
  description?: string;
  prn?: string;
  quantity?: number;
  to_be_performer?: PerformerNumber;
  order_detail?: string;
  equipment_detail?: string;
  remark?: string;
  unit_name?: string;
  type?: string;
  eligibility_type?: string;
  specimen_id?: number;
  specimen_code?: string;
  specimen_color?: any;
  lab_type_label?: string;
  specimen_time?: string;
  urgency?: string;
  xrayGroup?: string;
  mode?: string;
  note?: string;
  claimImaging?: string;
  p_type_code?: string;
  id?: number;
};

export type CheckBoxTemplateType = {
  LAB?: number[];
  XRAY?: number[];
  PROC?: number[];
  SUPPLY?: number[];
  OTHER?: number[];
};

export type SearchTemplateType = {
  division?: number | string;
  doctor?: number | string;
  name?: string;
  type?: "ALL" | "G" | "D" | "P";
};

export type SelectTemplateType = {
  id?: number;
  name?: string;
  type?: "G" | "D" | "P";
  division?: number | null;
  doctor?: number | null;
  doctorName?: string;
  lab_template_list?: LabTemplateList[];
  imaging_template_list?: ImagingTemplateList[];
  treatment_template_list?: TreatmentTemplateList[];
  supply_template_list?: SupplyTemplateList[];
  miscellaneous_template_list?: MiscellaneousTemplateList[];
};

export const templateList = {
  LAB: "lab_template_list",
  XRAY: "imaging_template_list",
  PROC: "treatment_template_list",
  SUPPLY: "supply_template_list",
  OTHER: "miscellaneous_template_list",
} as const;

export type TemplateKey = keyof typeof templateList;

export type LabTemplateList = {
  specimen_id?: number;
  specimen_code: string;
  id?: number;
  test?: number;
  specimen_time?: string;
  urgency?: 1 | 2 | 3 | string; // 1=ROUTINE, 2=STAT, 3=FAST_TRACK
  note?: string;
  quantity?: number;
};

export type ImagingTemplateList = {
  id?: number;
  product?: number;
  quantity?: number;
  eligibility_type?: 1 | 2 | 3 | 4 | 5; // 1=TREATMENT เพื่อการรักษา, 2=BEAUTY เพื่อเสริมสวย, 3=PATIENT_PAY ผู้ป่วยแสดงความจำนงชำระเงินเอง, 4=NOT_INDICATOR ใช้ไม่ตรงข้อบ่งชี้, 5=SELF_REIMB ผู้ป่วยนำไปเบิกเอง
  urgency?: 1 | 2 | 3; // 1=ROUTINE, 2=STAT, 3=FAST_TRACK
  note?: string;
};

export type TreatmentTemplateList = {
  icd9cm_term?: string;
  icd9cm_code?: string;
  code?: string;
  name?: string;
  id?: number;
  icd9?: {
    icd10_id?: number;
    icdcode?: string;
    icdterm?: string;
    medterm?: string;
    sublevel?: boolean;
  };
  product?: number;
  quantity?: number;
  eligibility_type?: 1 | 2 | 3 | 4 | 5; // 1=TREATMENT เพื่อการรักษา, 2=BEAUTY เพื่อเสริมสวย, 3=PATIENT_PAY ผู้ป่วยแสดงความจำนงชำระเงินเอง, 4=NOT_INDICATOR ใช้ไม่ตรงข้อบ่งชี้, 5=SELF_REIMB ผู้ป่วยนำไปเบิกเอง
  icd9cm?: number;
  to_be_performer?: PerformerNumber; // 1=DOCTOR, 2=NURSE, 3=OTHER
  order_detail?: string;
  equipment_detail?: string;
  remark?: string;
};

export type SupplyTemplateList = {
  mode?: string;
  name?: string;
  code?: string;
  id?: number;
  supply?: number;
  quantity?: number;
  type?: SupplyTypeNumber;
  eligibility_type?: 1 | 2 | 3 | 4 | 5; // 1=TREATMENT เพื่อการรักษา, 2=BEAUTY เพื่อเสริมสวย, 3=PATIENT_PAY ผู้ป่วยแสดงความจำนงชำระเงินเอง, 4=NOT_INDICATOR ใช้ไม่ตรงข้อบ่งชี้, 5=SELF_REIMB ผู้ป่วยนำไปเบิกเอง
  remark?: string;
};

export type MiscellaneousTemplateList = {
  id?: number;
  product?: number;
  quantity?: number;
  eligibility_type?: 1 | 2 | 3 | 4 | 5; // 1=TREATMENT เพื่อการรักษา, 2=BEAUTY เพื่อเสริมสวย, 3=PATIENT_PAY ผู้ป่วยแสดงความจำนงชำระเงินเอง, 4=NOT_INDICATOR ใช้ไม่ตรงข้อบ่งชี้, 5=SELF_REIMB ผู้ป่วยนำไปเบิกเอง
};

export type SearchedItemList = {
  id?: number;
  unit_name?: string;
  p_type_code?: string;
  p_type_name?: string;
  active_flag_label?: string;
  price_normal?: number;
  code?: string;
  name?: string;
  name_en?: string;
  service_code?: string;
  active_flag?: number;
  has_lots?: boolean;
  overall_cost?: null;
  extra?: {
    peak_id?: string;
  };
  unit?: number;
  p_type?: number;
  of_division?: null;
};

export type SelectedDivision = {
  id?: number;
  code?: string;
  name?: string;
  name_en?: string;
  name_code?: string;
  type?: number;
  type_label?: string;
  organization?: null;
  profile?: {
    id?: number;
    code?: null;
    is_oa?: boolean;
    feature?: null;
  };
  useRights?: any[];
};

const performerKeyMap = {
  1: "DOCTOR",
  2: "NURSE",
  3: "OTHER",
} as const;

type PerformerNumber = keyof typeof performerKeyMap;
type PerformerKey = (typeof performerKeyMap)[PerformerNumber];

type TreatmentOrderData = {
  product?: number;
  quantity?: number;
};

const supplyTypeKeyMap = {
  1: "HOME_OPD",
  2: "HOME_IPD",
  3: "REFILL_OPD",
  4: "REFILL_IPD",
  6: "STAT",
  7: "COST_CENTER",
  8: "ONE_DAY",
} as const;

type SupplyTypeNumber = keyof typeof supplyTypeKeyMap;
type SupplyTypeKey = (typeof supplyTypeKeyMap)[SupplyTypeNumber];

const Masters = [
  // treatment
  ["claimImaging", {}],
  ["unit", {}],
  ["doctor", {}],
  ["specimenList", {}],
] as const;

export type MasterOptionsType = Record<(typeof Masters)[number][0], OptionType[]>;

export type OptionType = {
  code?: string;
  name?: string;
  key?: number | string;
  text?: string;
  value?: number | string;
};

export const StateInitial: State = {
  // sequence
  OrderSetTemplateSequence: {
    sequenceIndex: null,
  },
};

export type Event =
  | { message: "RunSequence"; params: {} }
  | { message: "GetMasterData"; params: any }
  | { message: "CheckEncounterLocker"; params: { ids?: number[] } };

export type Data = {
  division?: number;
};

export const DataInitial = {};

type Handler = (controller: WasmController<State, Event, Data, Props>, params?: any) => any;

export const Start: Handler = async (controller, params) => {
  await controller.handleEvent({
    message: "GetMasterData",
    params: {
      masters: Masters,
    },
  });

  controller.setState(
    {
      OrderSetTemplateSequence: {
        sequenceIndex: "SearchAndAction",
        searchTemplate: {
          type: "ALL",
          division: "ALL",
          doctor: "ALL",
        },
      },
    },
    () => SearchAndAction(controller, { action: "searchTemplate", ...params })
  );
};

export const SearchAndAction: Handler = async (controller, params) => {
  const state = controller.getState();

  if (params.action === "getDetailData") {
    const state = controller.getState();

    if (params?.key === "PROC") {
      const [treatmentListRes, treatmentListErr, treatmentListNet] = await TreatmentList.list({
        params: {
          code: params?.data?.product,
        },
        apiToken: controller.apiToken,
      });

      if (treatmentListRes) {
        controller.setState({
          OrderSetTemplateSequence: {
            ...state.OrderSetTemplateSequence,
            selectDetail: {
              ...treatmentListRes,
              ...params?.data,
              p_type_code: "PROC",
            },
          },
        });
      } else {
        controller.setState({
          OrderSetTemplateSequence: {
            ...state.OrderSetTemplateSequence,
            selectDetail: {
              ...params?.data,
            },
          },
        });
      }
    } else if (params?.key === "SUPPLY") {
      const [supplyDetailRes, supplyDetailErr, supplyDetailNet] = await SupplyDetail.retrieve({
        pk: params?.data?.supply,
        apiToken: controller.apiToken,
      });

      if (supplyDetailRes) {
        controller.setState({
          OrderSetTemplateSequence: {
            ...state.OrderSetTemplateSequence,
            selectDetail: {
              ...supplyDetailRes,
              ...params?.data,
              mode: supplyDetailRes?.mode,
              p_type_code: "SUPPLY",
            },
          },
        });
      } else {
        controller.setState({
          OrderSetTemplateSequence: {
            ...state.OrderSetTemplateSequence,
            selectDetail: {
              ...params?.data,
            },
          },
        });
      }
    } else if (params?.key === "LAB") {
      controller.setState({
        OrderSetTemplateSequence: {
          ...state.OrderSetTemplateSequence,
          selectDetail: {
            ...params?.data,
            lab_type_label: "In lab",
            p_type_code: "LAB",
          },
        },
      });
    } else if (params?.key === "XRAY") {
      controller.setState({
        OrderSetTemplateSequence: {
          ...state.OrderSetTemplateSequence,
          selectDetail: {
            ...params?.data,
            xrayGroup: "General X-ray Group",
            p_type_code: "XRAY",
          },
        },
      });
    } else if (params?.key === "OTHER") {
      controller.setState({
        OrderSetTemplateSequence: {
          ...state.OrderSetTemplateSequence,
          selectDetail: {
            ...params?.data,
          },
        },
      });
    }
  } else if (params.action === "searchIcd9") {
    const state = controller.getState();
    let icd9Key = state.OrderSetTemplateSequence?.selectDetail?.icd9?.icdterm || "";

    if (icd9Key.length >= 3) {
      const [
        [icdcodeRes, icdcodeErr, icdcodeNet],
        [medtermRes, medtermErr, medtermNet],
        [icdtermRes, icdtermErr, icdtermNet],
      ] = await Promise.all([
        icd9cmKeyUp.post({
          method: "icdcode",
          data: {
            icdcode: icd9Key,
          },
          apiToken: controller.apiToken,
        }),
        icd9cmKeyUp.post({
          method: "medterm",
          data: {
            medterm: icd9Key,
          },
          apiToken: controller.apiToken,
        }),
        icd9cmKeyUp.post({
          method: "icdterm",
          data: {
            icdterm: icd9Key,
          },
          apiToken: controller.apiToken,
        }),
      ]);

      controller.setState({
        OrderSetTemplateSequence: {
          ...state.OrderSetTemplateSequence,
          searchIcd9: [...icdcodeRes?.response, ...medtermRes?.response, ...icdtermRes?.response],
        },
      });
    }
  } else if (params.action === "editOrderDetail") {
    const state = controller.getState();

    const { selectDetail, selectTemplate } = state.OrderSetTemplateSequence ?? {};
    const selectedId = params?.selectedId;
    const typeKey = templateList[selectDetail?.p_type_code as keyof typeof templateList];

    if (typeKey && selectTemplate?.[typeKey]) {
      selectTemplate[typeKey] = selectTemplate[typeKey].map((item: any) =>
        item?.id === selectedId ? selectDetail : item
      );
    }

    controller.setState({
      OrderSetTemplateSequence: {
        ...state.OrderSetTemplateSequence,
        selectTemplate,
        selectDetail: {},
      },
    });
  } else if (params.action === "searchTemplate") {
    const state = controller.getState();

    controller.setState({
      buttonLoadCheck: {
        ...state.buttonLoadCheck,
        [`${params.cardKey}_${params.action}`]: "LOADING",
      },
    });

    const filterData = Object.fromEntries(
      Object.entries(state.OrderSetTemplateSequence?.searchTemplate || {}).filter(([key, value]) =>
        ["division", "doctor", "type"].includes(key) ? value !== "ALL" : true
      )
    );

    const [orderSetTemplateRes, orderSetTemplateErr, orderSetTemplateNet] =
      await OrderSetTemplateList.list({
        params: filterData,
        apiToken: controller.apiToken,
        extra: { division: controller.data.division },
      });

    if (orderSetTemplateRes) {
      controller.setState({
        buttonLoadCheck: {
          ...state.buttonLoadCheck,
          [`${params.cardKey}_${params.action}`]: "SUCCESS",
        },
        OrderSetTemplateSequence: {
          ...state.OrderSetTemplateSequence,
          templateList: orderSetTemplateRes?.items,
          selectTemplate: {},
        },
      });
    } else {
      controller.setState({
        buttonLoadCheck: {
          ...state.buttonLoadCheck,
          [`${params.cardKey}_${params.action}`]: "ERROR",
        },
      });
    }
  } else if (params.action === "getTemplateDetail") {
    const state = controller.getState();

    const [orderSetTemplateRes, orderSetTemplateErr, orderSetTemplateNet] =
      await OrderSetTemplateDetail.retrieve({
        pk: params.pk,
        apiToken: controller.apiToken,
        extra: { division: controller.data.division },
      });

    if (orderSetTemplateRes) {
      const mapOrderSetTemplate = (res: any) => {
        const {
          lab_templates,
          imaging_templates,
          treatment_templates,
          supply_templates,
          miscellaneous_templates,
          ...rest
        } = res;

        const newLabTemplateList = (lab_templates || []).map((item: LabTemplateList) => {
          const urgency = urgencyOptions.find(
            (data: OptionType) => item?.urgency == data.text
          )?.value;
          return {
            ...item,
            urgency: urgency,
          };
        });

        const newImagingTemplates = (imaging_templates || []).map((item: ImagingTemplateList) => {
          return {
            ...item,
            urgency: Number(item?.urgency),
          };
        });

        const newTreatmentTemplates = (treatment_templates || []).map(
          (item: TreatmentTemplateList) => {
            return {
              ...item,
              icd9: {
                icd10_id: item?.icd9cm,
                icdcode: item?.icd9cm_code,
                icdterm: item?.icd9cm_term,
              },
            };
          }
        );

        return {
          ...rest,
          lab_template_list: newLabTemplateList || [],
          imaging_template_list: newImagingTemplates || [],
          treatment_template_list: newTreatmentTemplates || [],
          supply_template_list: supply_templates || [],
          miscellaneous_template_list: miscellaneous_templates || [],
        };
      };
      const selectTemplate = mapOrderSetTemplate(orderSetTemplateRes);

      let selectTemplateData = selectTemplate;

      if (orderSetTemplateRes?.doctor) {
        const [surgeonRes, surgeonErr, surgeonNet] = await DoctorDetail.retrieve({
          pk: orderSetTemplateRes?.doctor,
          apiToken: controller.apiToken,
        });

        if (surgeonRes) {
          selectTemplateData = {
            ...selectTemplate,
            doctorName: surgeonRes?.name_code,
          };
        }
      }

      controller.setState({
        buttonLoadCheck: {
          ...state.buttonLoadCheck,
          [`${params.cardKey}_${params.action}`]: "SUCCESS",
        },
        OrderSetTemplateSequence: {
          ...state.OrderSetTemplateSequence,
          selectTemplate: selectTemplateData,
          checkBoxTemplate: {
            LAB: [],
            XRAY: [],
            PROC: [],
            SUPPLY: [],
          },
        },
      });
    } else {
      controller.setState({
        buttonLoadCheck: {
          ...state.buttonLoadCheck,
          [`${params.cardKey}_${params.action}`]: "ERROR",
        },
      });
    }
  } else if (["saveTemplate", "editTemplate"].includes(params.action)) {
    const state = controller.getState();

    controller.setState({
      buttonLoadCheck: {
        ...state.buttonLoadCheck,
        [`${params.cardKey}_${params.action}`]: "LOADING",
      },
    });

    const errorMessage: string[] = [];

    const {
      lab_template_list = [],
      imaging_template_list = [],
      treatment_template_list = [],
      supply_template_list = [],
      miscellaneous_template_list = [],
    } = state.OrderSetTemplateSequence?.selectTemplate || {};

    if (!state.OrderSetTemplateSequence?.selectTemplate?.name) {
      errorMessage.push(`ระบุ ชื่อชุดคำสั่ง`);
    }

    const labTemplateList = lab_template_list.map((item) => {
      if (!item?.specimen_time) {
        errorMessage.push(`${item?.test}: ระบุ Specimen time`);
      }
      return {
        test: item?.test,
        specimen_id: item?.specimen_id,
        specimen_time: item?.specimen_time,
        urgency: item?.urgency,
        note: item?.note || "",
        ...(item?.id && {
          id: item?.id,
        }),
      };
    });

    const imagingTemplateList = imaging_template_list.map((item) => ({
      product: item?.product,
      quantity: item?.quantity,
      eligibility_type: item?.eligibility_type,
      urgency: item?.urgency,
      note: item?.note || "",
      ...(item?.id && {
        id: item?.id,
      }),
    }));

    const treatmentTemplateList = treatment_template_list.map((item) => {
      if (!item?.icd9) {
        errorMessage.push(`[${item?.code}] ${item?.name}: ระบุ ICD9`);
      }

      return {
        product: item?.product,
        quantity: item?.quantity,
        eligibility_type: item?.eligibility_type,
        icd9cm: item?.icd9?.icd10_id || item?.icd9cm,
        to_be_performer: item?.to_be_performer,
        order_detail: item?.order_detail,
        equipment_detail: item?.equipment_detail,
        remark: item?.remark || "",
        ...(item?.id && {
          id: item?.id,
        }),
      };
    });

    const supplyTemplateList = supply_template_list.map((item) => {
      if (!item?.type) {
        errorMessage.push(`[${item?.code}] ${item?.name}: ระบุ Supply type`);
      }

      return {
        supply: item?.supply,
        quantity: item?.quantity,
        type: item?.type,
        eligibility_type: item?.eligibility_type,
        remark: item?.remark || "",
        ...(item?.id && {
          id: item?.id,
        }),
      };
    });

    const miscellaneousTemplateList = miscellaneous_template_list.map((item) => {
      return {
        product: item?.product,
        quantity: item?.quantity,
        eligibility_type: item?.eligibility_type,
      };
    });

    if (errorMessage.length !== 0) {
      controller.setState({
        buttonLoadCheck: {
          ...state.buttonLoadCheck,
          [`${params.cardKey}_${params.action}`]: "ERROR",
        },
        errorMessage: {
          ...state.errorMessage,
          [`${params.cardKey}_${params.action}`]: errorMessage,
        },
      });
    } else {
      const data = {
        name: state.OrderSetTemplateSequence?.selectTemplate?.name,
        type: state.OrderSetTemplateSequence?.selectTemplate?.type,
        lab_template_list: labTemplateList,
        imaging_template_list: imagingTemplateList,
        treatment_template_list: treatmentTemplateList,
        supply_template_list: supplyTemplateList,
        miscellaneous_template_list: miscellaneousTemplateList,
        ...(state.OrderSetTemplateSequence?.selectTemplate?.division !== null && {
          division: state.OrderSetTemplateSequence?.selectTemplate?.division,
        }),
        ...(state.OrderSetTemplateSequence?.selectTemplate?.doctor !== null && {
          doctor: state.OrderSetTemplateSequence?.selectTemplate?.doctor,
        }),
      };

      const isSave = params.action === "saveTemplate";

      const [orderSetTemplateRes, orderSetTemplateErr, orderSetTemplateNet] = isSave
        ? await OrderSetTemplateList.create({
            data,
            apiToken: controller.apiToken,
            extra: { division: controller.data.division },
          })
        : await OrderSetTemplateDetail.update({
            pk: state.OrderSetTemplateSequence?.selectTemplate?.id,
            data,
            apiToken: controller.apiToken,
            extra: { division: controller.data.division },
          });

      controller.setState({
        buttonLoadCheck: {
          ...state.buttonLoadCheck,
          [`${params.cardKey}_${params.action}`]: orderSetTemplateRes ? "SUCCESS" : "ERROR",
        },
      });

      if (orderSetTemplateRes) {
        params.callback(false);
        SearchAndAction(controller, { action: "searchTemplate" });
      }
    }
  } else if (params.action === "deleteTemplate") {
    const state = controller.getState();

    controller.setState({
      buttonLoadCheck: {
        ...state.buttonLoadCheck,
        [`${params.cardKey}_${params.action}`]: "LOADING",
      },
    });

    const [orderSetTemplateRes, orderSetTemplateErr, orderSetTemplateNet] =
      await OrderSetTemplateDetail.delete({
        pk: state.OrderSetTemplateSequence?.selectTemplate?.id,
        apiToken: controller.apiToken,
        extra: { division: controller.data.division },
      });

    if (orderSetTemplateNet.status === 204) {
      controller.setState({
        buttonLoadCheck: {
          ...state.buttonLoadCheck,
          [`${params.cardKey}_${params.action}`]: "SUCCESS",
        },
      });
      params.callback(false);
      SearchAndAction(controller, { action: "searchTemplate" });
    } else {
      controller.setState({
        buttonLoadCheck: {
          ...state.buttonLoadCheck,
          [`${params.cardKey}_${params.action}`]: "ERROR",
        },
      });
    }
  } else if (params.action === "previewSupply") {
    const state = controller.getState();

    controller.setState({
      buttonLoadCheck: {
        ...state.buttonLoadCheck,
        [`${params.cardKey}_orderData`]: "LOADING",
      },
    });

    // ตรวจสอบ checkbox
    const selectedIds = state.OrderSetTemplateSequence?.checkBoxTemplate?.SUPPLY || [];
    if (!selectedIds.length) return;

    const supplyList = state.OrderSetTemplateSequence?.selectTemplate?.supply_template_list || [];

    const groupedByType: Record<SupplyTypeKey, any[]> = {
      STAT: [],
      HOME_OPD: [],
      HOME_IPD: [],
      REFILL_OPD: [],
      REFILL_IPD: [],
      COST_CENTER: [],
      ONE_DAY: [],
    };

    // แยก type
    supplyList
      .filter((item: SupplyTemplateList) => item.id && selectedIds.includes(item.id))
      .forEach((item: SupplyTemplateList) => {
        const typeKey = supplyTypeKeyMap[item.type as SupplyTypeNumber];
        if (typeKey) {
          groupedByType[typeKey].push({
            product: item.supply,
            quantity_request: item.quantity,
            mode: item.mode,
          });
        }
      });

    // SupplyOrderPreview
    const createOrderPromises = Object.entries(groupedByType)
      .filter(([_, items]) => items.length > 0)
      .map(([type, items]) => {
        return SupplyOrderPreview.create({
          data: {
            claim_payload: {},
            items: items,
            pk: 0,
            status: "",
            type: type,
            action: "REQUEST",
            encounter: state.selectedEncounter?.id,
          } as any,
          extra: {
            division: controller.data.division,
          },
          apiToken: controller.apiToken,
        });
      });

    let supplyQA: any = [];
    let errorMessage: string[] = [];

    const results = await Promise.all(createOrderPromises || []);

    results.forEach((item) => {
      // ตรวจสอบว่ามีคำถามหรือไม่
      if (item?.[0]?.claim_payload?.have_question) {
        supplyList?.forEach((supplyItem) => {
          let payloads = item?.[0]?.claim_payload?.payloads.find(
            (data: any) => data.product_id === supplyItem.supply
          );

          if (payloads && Object.keys(payloads?.answer_dict).length === 0) {
            supplyQA.push({
              ...payloads,
              isConfirm: false,
              type: item?.[0]?.type,
            });
          }
        });

        // ตรวจสอบ error
      } else if (item?.[1] !== "canceled" && item?.[1] !== null) {
        errorMessage.push(item?.[1]);
      }
    });

    // มี error
    if (errorMessage.length > 0) {
      controller.setState({
        buttonLoadCheck: {
          ...state.buttonLoadCheck,
          [`${params.cardKey}_orderData`]: "ERROR",
        },
        errorMessage: {
          ...state.errorMessage,
          [`${params.cardKey}_orderData`]: errorMessage,
        },
      });

      // มีคำถาม
    } else if (supplyQA.length > 0) {
      controller.setState({
        OrderSetTemplateSequence: {
          ...state.OrderSetTemplateSequence,
          supplyQA: supplyQA,
          supplyOrderPreview: results,
        },
        buttonLoadCheck: {
          ...state.buttonLoadCheck,
          [`${params.cardKey}_orderData`]: "SUCCESS",
        },
      });

      // ไม่มี error และคำถาม ให้บันทึก orderData
    } else {
      controller.setState({
        buttonLoadCheck: {
          ...state.buttonLoadCheck,
          [`${params.cardKey}_orderData`]: "SUCCESS",
        },
      });

      SearchAndAction(controller, { ...params, action: "orderData" });
    }
  } else if (params.action === "saveAnswer") {
    let state = controller.getState();

    controller.setState({
      buttonLoadCheck: {
        ...state.buttonLoadCheck,
        [`${params.cardKey}_${params.action}`]: "LOADING",
      },
    });

    const productId = params?.supplyData?.product_id;
    const supplyOrderPreview = (state.OrderSetTemplateSequence?.supplyOrderPreview || []).filter(
      (item) => item?.[0]?.type === params?.supplyData?.type
    )?.[0]?.[0];

    const payloads = supplyOrderPreview?.claim_payload?.payloads;

    const payloadIdx = payloads?.findIndex((i: any) => i.product_id === productId);
    if (payloadIdx !== -1 || payloadIdx !== undefined) {
      payloads[payloadIdx].answer_dict = params.supplyData.answer_dict;
    }

    const orderPreview = await SupplyOrderPreview.create({
      data: {
        pk: 0,
        status: "",
        type: params.supplyData?.type,
        items: [
          ...(supplyOrderPreview?.items?.map((i) => {
            const { id, ...rest } = i;
            return { ...rest };
          }) || []),
        ],
        action: "REQUEST",
        encounter: state.selectedEncounter?.id,
        claim_payload: {
          ...supplyOrderPreview?.claim_payload,
          payloads: payloads,
        },
      } as any,
      extra: {
        division: controller.data.division,
      },
      apiToken: controller.apiToken,
    });

    if (orderPreview[0]) {
      const supplyQA = (state.OrderSetTemplateSequence?.supplyQA || [])?.filter(
        (i: any) => i.product_id !== productId
      );

      state = controller.getState();
      controller.setState({
        OrderSetTemplateSequence: {
          ...state.OrderSetTemplateSequence,
          supplyQA: supplyQA,
        },
        buttonLoadCheck: {
          ...state.buttonLoadCheck,
          [`${params.cardKey}_${params.action}`]: "SUCCESS",
        },
      });

      if (supplyQA.length === 0) {
        SearchAndAction(controller, { ...params, action: "orderData" });
      }
    } else {
      controller.setState({
        buttonLoadCheck: {
          ...state.buttonLoadCheck,
          [`${params.cardKey}_${params.action}`]: "ERROR",
        },
        errorMessage: {
          ...state.errorMessage,
          [`${params.cardKey}_${params.action}`]: orderPreview[1],
        },
      });
    }
  } else if (params.action === "orderData") {
    const state = controller.getState();

    controller.setState({
      buttonLoadCheck: {
        ...state.buttonLoadCheck,
        [`${params.cardKey}_${params.action}`]: "LOADING",
      },
    });

    const handleLabOrder = async () => {
      const selectedIds = state.OrderSetTemplateSequence?.checkBoxTemplate?.LAB || [];
      if (!selectedIds.length) return;

      const labList = state.OrderSetTemplateSequence?.selectTemplate?.lab_template_list || [];

      const order_items = labList
        .filter((item: LabTemplateList) => item.id && selectedIds.includes(item.id))
        .map((item: LabTemplateList) => ({
          _id: null,
          urgency: urgencyOptions.find((opt) => opt.value === item.urgency)?.text || "ROUTINE",
          specimen: item.specimen_id,
          product: item.test,
          children: [],
        }));

      if (!order_items.length) return;

      const labData = await CentralLabOrderList.create({
        data: {
          action: "ORDER",
          allow_duplicate_flag: params.allow_duplicate_flag || false,
          encounter: state.selectedEncounter?.id,
          emr: state.selectedEmr?.id,
          order_items,
          order_status: 2,
          is_advance: false,
          progression_cycle: state.selectedProgressCycle?.id,
        },
        extra: { division: controller.data.division },
        apiToken: controller.apiToken,
      });

      console.log("labData", labData);
      return labData;
    };

    const handleXrayOrder = async () => {
      const selectedIds = state.OrderSetTemplateSequence?.checkBoxTemplate?.XRAY || [];
      if (!selectedIds.length) return;

      const xrayList = state.OrderSetTemplateSequence?.selectTemplate?.imaging_template_list || [];

      const order_items = xrayList
        .filter((item: ImagingTemplateList) => item.id && selectedIds.includes(item.id))
        .map((item: ImagingTemplateList) => ({
          urgency: urgencyOptions.find((opt) => opt.value === item.urgency)?.text || "ROUTINE",
          product: item.product,
        }));

      if (!order_items.length) return;

      const xrayData = await ImagingOrderList.create({
        data: {
          action: "ORDER",
          encounter: state.selectedEncounter?.id,
          emr: state.selectedEmr?.id,
          order_items,
          order_status: 2,
          extra: {
            out_time: false,
            secret: false,
            repeat_medication: false,
            lawsuit: false,
          },
        },
        extra: { division: controller.data.division },
        apiToken: controller.apiToken,
      });

      console.log("xrayData", xrayData);
      return xrayData;
    };

    const handleTreatmentOrder = async () => {
      const selectedIds = state.OrderSetTemplateSequence?.checkBoxTemplate?.PROC || [];
      if (!selectedIds.length) return;

      const treatmentList =
        state.OrderSetTemplateSequence?.selectTemplate?.treatment_template_list || [];

      const groupedByPerformer: Record<PerformerKey, TreatmentOrderData[]> = {
        DOCTOR: [],
        NURSE: [],
        OTHER: [],
      };

      treatmentList
        .filter((item: TreatmentTemplateList) => item.id && selectedIds.includes(item.id))
        .forEach((item: TreatmentTemplateList) => {
          const performerKey = performerKeyMap[item.to_be_performer as PerformerNumber];
          if (performerKey) {
            groupedByPerformer[performerKey].push({
              product: item.product,
              quantity: item.quantity,
            });
          }
        });

      const createOrderPromises = Object.entries(groupedByPerformer)
        .filter(([_, items]) => items.length > 0)
        .map(([performerStr, items]) => {
          return TreatmentOrderList.create({
            data: {
              action: "ORDER",
              encounter: state.selectedEncounter?.id,
              emr: state.selectedEmr?.id,
              order_items: items,
              order_status: 2,
              progression_cycle: state.selectedProgressCycle?.id,
              to_be_performer: performerStr as PerformerKey,
            },
            extra: { division: controller.data.division },
            apiToken: controller.apiToken,
          });
        });

      if (createOrderPromises.length > 0) {
        const results = await Promise.all(createOrderPromises);
        console.log("treatmentData", results);
        return results;
      }
    };

    const handleSupplyOrder = async () => {
      const selectedIds = state.OrderSetTemplateSequence?.checkBoxTemplate?.SUPPLY || [];
      if (!selectedIds.length) return;

      const supplyList = state.OrderSetTemplateSequence?.selectTemplate?.supply_template_list || [];

      const groupedByType: Record<SupplyTypeKey, any[]> = {
        STAT: [],
        HOME_OPD: [],
        HOME_IPD: [],
        REFILL_OPD: [],
        REFILL_IPD: [],
        COST_CENTER: [],
        ONE_DAY: [],
      };

      supplyList
        .filter((item: SupplyTemplateList) => item.id && selectedIds.includes(item.id))
        .forEach((item: SupplyTemplateList) => {
          const typeKey = supplyTypeKeyMap[item.type as SupplyTypeNumber];
          if (typeKey) {
            groupedByType[typeKey].push({
              product: item.supply,
              quantity_request: item.quantity,
              mode: item.mode,
            });
          }
        });

      const createOrderPromises = Object.entries(groupedByType)
        .filter(([_, items]) => items.length > 0)
        .map(([type, items]) => {
          return SupplyOrderList.create({
            data: {
              action: "REQUEST",
              encounter: state.selectedEncounter?.id,
              items,
              type: type as SupplyTypeKey,
            },
            extra: { division: controller.data.division },
            apiToken: controller.apiToken,
          });
        });

      if (createOrderPromises.length > 0) {
        const results = await Promise.all(createOrderPromises);
        console.log("supplyData", results);
        return results;
      }
    };

    const handleMiscellaneousOrder = async () => {
      let toDate = moment();

      const selectedIds = state.OrderSetTemplateSequence?.checkBoxTemplate?.OTHER || [];
      if (!selectedIds.length) return;

      const miscellaneousList =
        state.OrderSetTemplateSequence?.selectTemplate?.miscellaneous_template_list || [];

      const miscellaneous_orders = miscellaneousList
        .filter((item: MiscellaneousTemplateList) => item.id && selectedIds.includes(item.id))
        .map((item: MiscellaneousTemplateList) => {
          const { id, ...rest } = item;
          return {
            ...rest,
            encounter: state.selectedEncounter?.id,
            eligibility_type: eligibilityTypeOptions?.filter(
              (option) => option.value === rest?.eligibility_type
            )?.[0]?.textEN,
            charges_date: formatDate(toDate),
            override_unit_price: "0.00",
          };
        });

      if (!miscellaneous_orders.length) return;

      const miscellaneousData = await MiscellaneousOrderListCreate.post({
        data: { miscellaneous_orders: miscellaneous_orders },
        extra: { division: controller.data.division },
        apiToken: controller.apiToken,
      });

      console.log("miscellaneousData", miscellaneousData);
      return miscellaneousData;
    };

    if (params.isOrderLab) {
      const labData = await handleLabOrder()

      if (labData?.[0]) {
        params.callback(false);

        controller.setState({
          OrderSetTemplateSequence: {
            ...state.OrderSetTemplateSequence,
            selectTemplate: {},
            duplicateLabDetected: [],
          },
          buttonLoadCheck: {
            ...state.buttonLoadCheck,
            [`${params.cardKey}_${params.action}`]: "SUCCESS",
          },
        });
      } else {
        controller.setState({
          OrderSetTemplateSequence: {
            ...state.OrderSetTemplateSequence,
            duplicateLabDetected: [],
          },
          buttonLoadCheck: {
            ...state.buttonLoadCheck,
            [`${params.cardKey}_${params.action}`]: "ERROR",
          },
          errorMessage: {
            ...state.errorMessage,
            [`${params.cardKey}_${params.action}`]: labData,
          },
        });
      }
    } else {
      const results = await Promise.all([
        handleLabOrder(),
        handleXrayOrder(),
        handleTreatmentOrder(),
        handleSupplyOrder(),
        handleMiscellaneousOrder(),
      ]);

      const errorMessage: string[] = [];
      let duplicateLabDetected: string[] = [];

      const errorsByKey = ["Lab", "X-ray", "Treatment", "Supply", "Miscellaneous"].reduce(
        (acc, key, index) => {
          const section = results[index] || [];

          if ([2, 3].includes(index)) {
            const errors = section
              .map((item: any) => item?.[1])
              .filter((err: any) => !!err)
              .map(String);

            if (errors.length > 0) {
              acc[key] = errors;
              errorMessage.push(`${key}: ${errors}`);
            }

            return acc;
          } else {
            const errors = section?.[1];

            if (errors) {
              if (
                errors.code &&
                [
                  "DUPLICATE_CENTRAL_LAB_ITEM_NAME",
                  "DUPLICATE_SAME_ORDER",
                  "DUPLICATE_SAME_ORDER_AND_DUPLICATE_CENTRAL_LAB_ITEM_NAME",
                ].includes(errors.code[0])
              ) {
                duplicateLabDetected = errors.message;
              } else {
                acc[key] = errors;

                if (Array.isArray(errors)) {
                  errorMessage.push(`${key}: ${errors.join(", ")}`);
                } else if (typeof errors === "object") {
                  const messages = Object.entries(errors).flatMap(([_, val]: [string, any]) =>
                    Array.isArray(val)
                      ? val.map((v) => (typeof v === "object" ? JSON.stringify(v) : String(v)))
                      : [String(val)]
                  );
                  errorMessage.push(`${key}: ${messages.join(", ")}`);
                } else {
                  errorMessage.push(`${key}: ${String(errors)}`);
                }
              }
            }
            return acc;
          }
        },
        {} as Record<string, string[]>
      );

      const checkErr = Object.keys(errorsByKey).length > 0;

      if (checkErr || duplicateLabDetected.length > 0) {
        controller.setState({
          OrderSetTemplateSequence: {
            ...state.OrderSetTemplateSequence,
            duplicateLabDetected: duplicateLabDetected,
          },
          buttonLoadCheck: {
            ...state.buttonLoadCheck,
            [`${params.cardKey}_${params.action}`]: "ERROR",
          },
          ...(errorMessage.length > 0 && {
            errorMessage: {
              ...state.errorMessage,
              [`${params.cardKey}_${params.action}`]: errorMessage,
            },
          }),
        });
      } else {
        params.callback(false);

        controller.setState({
          OrderSetTemplateSequence: {
            ...state.OrderSetTemplateSequence,
            selectTemplate: {},
            duplicateLabDetected: duplicateLabDetected,
          },
          buttonLoadCheck: {
            ...state.buttonLoadCheck,
            [`${params.cardKey}_${params.action}`]: "SUCCESS",
          },
        });
      }
    }
  }
};

export const supplyMode = {
  EQUIPMENT: "Equipment",
  SUPPLY: "Supply",
  BOTH: "Both",
};

export type SupplyModeKey = keyof typeof supplyMode;

export const urgencyOptions = [
  { key: 1, value: 1, text: "ROUTINE" },
  { key: 2, value: 2, text: "STAT" },
  {
    key: 3,
    value: 3,
    text: "FAST_TRACK",
  },
];

export const eligibilityTypeOptions = [
  { key: 1, value: 1, text: "เพื่อการรักษา", textEN: "TREATMENT" },
  { key: 2, value: 2, text: "เพื่อเสริมสวย", textEN: "BEAUTY" },
  {
    key: 3,
    value: 3,
    text: "ผู้ป่วยแสดงความจำนงชำระเงินเอง",
    textEN: "PATIENT_PAY",
  },
  { key: 4, value: 4, text: "ใช้ไม่ตรงข้อบ่งชี้", textEN: "NOT_INDICATOR" },
  {
    key: 5,
    value: 5,
    text: "ผู้ป่วยนำไปเบิกเอง",
    textEN: "SELF_REIMB",
  },
];
